export class TruncateNumber {
  private readonly _value: string;

  constructor(value: number | string) {
    this._value = value.toString();
  }

  public places(digits: number = 2) {
    const regex = new RegExp('^-?\\d+(?:.\\d{0,' + (digits || -1) + '})?');
    return this._value.match(regex)?.[0] ?? this._value;
  }
}
